import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Button from "../../buttons/Button";
import Grid from "../../grid/GridWrapper";
import Tabs from "../../TabsWrapper";
import Tab from "../../Tab";
import DropDownList from "../../forms/DropDownList";
import Checkbox from "../../forms/Checkbox";
import flags from "../../utils/flags";
import withMeta from '../../utils/withMeta';
import LoadingPanel from "../../LoadingPanel";
import { useDidMount, useFirstRender } from '../../utils/hooks';
import { showMsg } from "../../utils/logger";

const AKT_DATA = [
  { id: 0, name: 'Doplniť práva' },
  { id: 1, name: 'Zaktualizovať práva' },
  { id: 2, name: 'Obnoviť práva' }
];

const PravaPrj = (props) => {
  const [state, setState] = useState({
    isLoading: true,
    data: [],
    total: 0,
    selected: [],
    fixedFilter: {},
    akt: AKT_DATA[0],
    readOnly: false,
  });

  // aby useEffect(..., [props.refresh]) nerobil kontrolu _.isEqual(oldSelected, newSelected) pri 1. rendery, 
  // lebo prv sa spusta useEffect az po nom getList(), ktory nastavi oldSelected a newSelected
  const firstRender = useFirstRender();

  const getList = async (filter, sort, page, primaryField = "IPrjSkupUz") => {
    try {
      setState({ ...state, isLoading: true, data: [], total: 0 });
      const res = await props.meta.getList(primaryField, filter, sort, page, props.db);

      setState({ ...state, isLoading: false, data: res.Data.Items, total: res.Data.TotalRecords });
      props.getListSuccess(res);
    }
    catch (error) {
      setState({ ...state, isLoading: false, data: [], total: 0 });
      props.getListFailure(error);
    }
  }

  const handleSelect = (selected) => {
    setState({ ...state, selected });
  }

  // componentDidMount
  useDidMount(() => {
    const fixedFilter = { filters: [{ field: "Uz.IUz", operator: "eq", value: props.uz.IUz }, { field: "Zrus", operator: "eq", value: false }] };
    setState({ ...state, fixedFilter });
  });

  // componentDidUpdate
  useEffect(() => {
    if (!firstRender) {
      onNext();
    }
    // eslint-disable-next-line
  }, [props.refresh]);

  const onNext = async () => {
    try {
      setState({ ...state, isLoading: true });
      const data = state.selected.map(x => ({ iAkt: state.akt.id, iPrj: x.Prj.IPrj, lPristup: state.readOnly, iSkup: null, iUz: props.uz.IUz }));
      await props.meta.setPravaPrj(data, props.db);
      setState({ ...state, isLoading: false });
      props.showMsg("Práva úspešne priradené");
      props.onSubmit();
    }
    catch (error) {
      setState({ ...state, isLoading: false });
      props.showMsg(error.message, 'error');
    }
  }

  const handleChange = (name, value) => {
    setState({ ...state, [name]: value });
  }

  return (
    <>
      <LoadingPanel isLoading={state.isLoading} />
      <Tabs localTabsType>
        <Tab title="">
          <Grid
            toolbarActions={<div className="akc-prava">
              <DropDownList
                name="akt"
                data={AKT_DATA}
                textField="name"
                onChange={handleChange}
                value={state.akt}
              />
              <Checkbox
                label="Na čítanie"
                name="readOnly"
                onChange={handleChange}
                value={state.readOnly}
              />
            </div>}
            primaryField="IPrjSkupUz"
            isLoading={state.isLoading}
            data={state.data}
            total={state.total}
            schema={[]}
            onChange={getList}
            onGetList={() => { }}
            onGet={() => { }}
            selected={state.selected}
            onSelect={handleSelect}
            hidden={flags.ADD | flags.CANCEL | flags.COPY | flags.DELETE | flags.DETAIL}
            multiple
            fixedFilter={state.fixedFilter}
            withMeta
          />
        </Tab>
        <></>
      </Tabs>
      <Button
        buttonWrapperClassName={"next-button"}
        label={"Nastaviť práva"}
        onClick={onNext}
        disabled={state.selected.length === 0}
        primary
      />
    </>
  );

}

PravaPrj.propTypes = {
  refresh: PropTypes.number,
  uz: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired
}

const mapStateToProps = () => ({
});

const mapDispatchToProps = dispatch => ({
  getListSuccess: res => dispatch({ type: 'GET_LIST_SUCCESS', res }),
  getListFailure: error => dispatch({ type: 'GET_LIST_FAILURE', error }),
  createFailure: error => dispatch({ type: 'CREATE_FAILURE', error }),
  showMsg: (msg, msgType = 'ok') => dispatch(showMsg(msg, msgType))
})


export default withMeta(connect(mapStateToProps, mapDispatchToProps)(PravaPrj));
